import { useEffect, useState } from 'react'
import { getCreateUpload, subscribeCreateUpload } from '../utils/createUpload'

export const useCreateUpload = () => {
  const [job, setJob] = useState(getCreateUpload)
  useEffect(() => subscribeCreateUpload(setJob), [])
  return job
}
